import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { LimitReactiveList3fo42zjtyuog7 as LimitReactiveList } from './LimitReactiveList.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { children3c86uuk2wm9cf as children } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/Recycler2.ext.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function children_0(_this__u8e3s4, items, id, render) {
  reactive(_this__u8e3s4, VOID, ($this$reactive) => {
    var inner = $this$reactive.invoke_r7m7el_k$(items);
    var tmp;
    if (isInterface(inner, LimitReactiveList())) {
      var tmp_0;
      if (inner.get_limit_iuokuq_k$() < ($this$reactive.invoke_r7m7el_k$(_this__u8e3s4.lastIndex_1) + 50 | 0)) {
        inner.set_limit_mo5fx2_k$($this$reactive.invoke_r7m7el_k$(_this__u8e3s4.lastIndex_1) + 100 | 0);
        tmp_0 = Unit_instance;
      }
      tmp = tmp_0;
    }
    return Unit_instance;
  });
  children(_this__u8e3s4, remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$($this$remember.invoke_r7m7el_k$(items))), id, render);
}
//region block: exports
export {
  children_0 as children1vanzv8wlhhqv,
};
//endregion

//# sourceMappingURL=RecyclerViewExt.mjs.map
